export default ({
  detailId = 0,
  assetId = 0,
  itemId = 0,
  teaserId = 0,
  anchor,
} = {}) =>
  `#/detail/${detailId}/${assetId}/${teaserId || itemId}${
    anchor ? "/" + anchor : ""
  }`
